define( [ "./selector-sizzle" ], function() {} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/selector.js
 ** module id = 834
 ** module chunks = 2
 **/